import { Component } from '@angular/core';
import { ToastController, ActionSheetController, AlertController } from '@ionic/angular';
import { version } from './global.config';
import { Subscription } from 'rxjs';
import { User } from './signin/credentials';
import { TranslateService } from '@ngx-translate/core';

@Component({
  selector: 'app-root',
  templateUrl: 'app.component.html',
  styleUrls: ['app.component.scss'],
})
export class AppComponent {

  version: string = version;
  currentUser: User | null;
  backButtonSubscription: Subscription;
  interval: any;

  constructor(
    private toastController: ToastController,
    public actionSheetCtrl: ActionSheetController,
    public alertController: AlertController,
    private translate: TranslateService
  ) {
    this.translate.addLangs(['en', 'fr', 'ar']);
    this.translate.setDefaultLang('fr');

    const browserLang = this.translate.getBrowserLang();
    this.translate.use(browserLang.match(/en|fr|ar/) ? browserLang : 'fr');

    this.currentUser = JSON.parse(localStorage.getItem('currentUser') || 'null');
    this.checkPreviousAuthorization();
  }

  // Vérification de l'authentification et affichage du toast en cas de session expirée
  async checkPreviousAuthorization() {
    if (!this.currentUser) {
      const toast = await this.toastController.create({
        message: this.translate.instant('APP.SESSION_EXPIRED'),
        duration: 4000,
        position: 'top',
        color: 'warning'
      });
      await toast.present();
    }
  }

  // Alert de confirmation pour quitter l'application
  async presentExitAlert() {
    const alert = await this.alertController.create({
      header: this.translate.instant('APP.EXIT_TITLE'),
      message: this.translate.instant('APP.EXIT_MESSAGE'),
      buttons: [
        {
          text: this.translate.instant('APP.CANCEL'),
          role: 'cancel',
          handler: () => {
            this.alertController.dismiss();
          }
        },
        {
          text: this.translate.instant('APP.QUIT'),
          handler: () => {
            navigator['app'].exitApp();
          }
        }
      ]
    });
    await alert.present();
  }
}
